import templateUrl from "emun.vendor/vendor-file-details.htm";
import VendorFileDetailsController from "emun.vendor/vendor-file-details.controller";
import open from "webmodals/open";

let VendorFileDetails = options => {
  let modalInstance = open({
    size: options.size || "md",
    templateUrl: options.templateUrl || templateUrl,
	  controller: VendorFileDetailsController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default VendorFileDetails;
